import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { CardMedia, NotificationBadge, Typography, } from '@one-thd/sui-atomic-components';
import { getLineItemQuantity } from '../util/general';
import { CustomImage } from '../../shared/CustomImage';
import { generateImageUrl } from '../../../utils/general';
export var pickupItemImages = function (fulfillmentGroup, updatedAddressData, isDeliveryDetails) {
    var _a, _b;
    var cartLineItems = (_b = (_a = updatedAddressData === null || updatedAddressData === void 0 ? void 0 : updatedAddressData.ordersInfo) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.newOrder.lineItems;
    var mappedLineItems = cartLineItems.map(function (cartItem) {
        var _a, _b;
        var fulfillmentGroupLineItem = (_a = fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (groupItem) { return groupItem.lineId === cartItem.lineId; });
        return {
            lineId: cartItem.lineId,
            estStartDeliveryDate: cartItem.estStartDeliveryDate,
            estEndDeliveryDate: cartItem.estEndDeliveryDate,
            currentQuantity: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.currentQuantity,
            cancelledQuantity: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.cancelledQuantity,
            originalOrderedQuantity: (_b = fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.originalOrderedQuantity) !== null && _b !== void 0 ? _b : fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.orginalOrderedQuantity,
            quantity: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.quantity,
            returnedQuantity: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.returnedQuantity,
            statusCode: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.statusCode,
            workOrderFulfilledQty: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.workOrderFulfilledQty,
            qtyToPrint: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.qtyToPrint,
            brandName: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.brandName,
            imageUrl: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.imageUrl,
        };
    });
    var groupedLineItems = mappedLineItems.reduce(function (acc, item) {
        var key = "".concat(item.estStartDeliveryDate, ":").concat(item.estEndDeliveryDate);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
    var sortedGroupedLineItems = Object.entries(groupedLineItems).sort(function (_a, _b) {
        var keyA = _a[0];
        var keyB = _b[0];
        var _c = keyA
            .split(':')
            .map(function (date) { return new Date(date).getTime(); }), startA = _c[0], endA = _c[1];
        var _d = keyB
            .split(':')
            .map(function (date) { return new Date(date).getTime(); }), startB = _d[0], endB = _d[1];
        if (startA === startB) {
            return endA - endB;
        }
        return startA - startB;
    });
    function formatDeliveryDates(estStartDeliveryDate, estEndDeliveryDate) {
        var startDate = DateTime.fromISO(estStartDeliveryDate);
        var endDate = DateTime.fromISO(estEndDeliveryDate);
        if (endDate > startDate) {
            return "".concat(startDate.toFormat('ccc, LLLL dd'), " - ").concat(endDate.toFormat('ccc, LLLL dd'));
        }
        return startDate.toFormat('ccc, LLLL dd');
    }
    var estimatedDeliveryDates = function (estStartDeliveryDate, estEndDeliveryDate) { return (React.createElement(Typography, { variant: "body-lg" },
        "Estimated Delivery:",
        ' ',
        React.createElement("span", { className: "sui-font-bold", "data-testid": "delivery-date" }, formatDeliveryDates(estStartDeliveryDate, estEndDeliveryDate)))); };
    var ItemImage = function (item) {
        var _a, _b;
        return useMemo(function () { return function () {
            var _a;
            return (React.createElement(CustomImage, { src: (_a = generateImageUrl(item)) !== null && _a !== void 0 ? _a : '', alt: item === null || item === void 0 ? void 0 : item.description, lazy: true, width: "48", height: "48" }));
        }; }, [(_b = (_a = updatedAddressData === null || updatedAddressData === void 0 ? void 0 : updatedAddressData.ordersInfo) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.newOrder.lineItems]);
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-5 " }, sortedGroupedLineItems.map(function (_a, index) {
        var key = _a[0], items = _a[1];
        var _b = key.split(':'), estStartDeliveryDate = _b[0], estEndDeliveryDate = _b[1];
        return (React.createElement("div", { key: index },
            !isDeliveryDetails &&
                estimatedDeliveryDates(estStartDeliveryDate, estEndDeliveryDate),
            React.createElement("div", { className: classNames('sui-flex sui-gap-5 sui-flex-wrap', {
                    'sui-mt-4': !isDeliveryDetails,
                    'sui-mb-4': isDeliveryDetails,
                }), "data-testid": "pickup-item-images" }, items.map(function (item) { return (React.createElement(NotificationBadge, { key: item.lineId, variant: "strong", size: "small", color: "primary", badgeContent: getLineItemQuantity(item) },
                React.createElement(CardMedia, { component: ItemImage(item) }))); })),
            isDeliveryDetails &&
                estimatedDeliveryDates(estStartDeliveryDate, estEndDeliveryDate)));
    })));
};
